import React, { useEffect } from 'react'

import { IpGateContainer as Container } from 'mytours-read-common'

import ReadyGateComponent from './ReadyGate'

const ERROR_CONTENT_IPBLOCKED = 3

/**
 * Redirects to the IP blocked page if the app metadata fetch fails with an IP
 * blocked error.
 * @param props
 * @returns
 */
const IpGate: React.FC<Container.Actions> = ({ fetchAppMetaData }) => {
	useEffect(() => {
		fetchAppMetaData(error => {
			if (!(error instanceof Response)) return
			if (error.status === 401) return location.replace('/public/404.html')

			error.text().then(text => {
				try {
					const data = JSON.parse(text)
					if (data.error_code === ERROR_CONTENT_IPBLOCKED)
						location.replace(data.redirect_url ? data.redirect_url : '/public/403-ipblocked.html')
				} catch (e) {
					// If parsing fails, do nothing. Could be a disabled project.
					console.error('fetchAppMetaData: failed to parse JSON response:', e);
				}
			})
		})
	}, [fetchAppMetaData])

	return <ReadyGateComponent />
}

const IpGateComponent = Container.default(IpGate)
export default IpGateComponent
